<template>
  <div :class="['radio-group', {dropdowncontrol:isDropdownControlled}]">
    <p>{{ question }}</p>
    <div v-for="(answer) in options.options" v-bind:key="answer.value">
      <b-radio type="radio" v-bind:name="radioName" :native-value="answer.value" v-model="checked" :tabindex="tab"
               @input="questionAnswered" :key="answer.value" :disabled="isDisabled" :class="{mandatory: isMandatory}">
        {{answer.text}}
      </b-radio>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RadiobuttonQuestion',
  props: {
    question: String,
    options: Object,
    isDisabled: Boolean,
    radioName: String,
    isMandatory: Boolean,
    isDropdownControlled: Boolean,
    existingValue: {
      type: String,
      default: null,
    },
    tab: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    questionAnswered() {
      this.$emit('question-answered', this.options.options.find((o) => o.value === this.checked));
    },
  },
  mounted() {
    if (this.existingValue) {
      this.questionAnswered();
    }
  },
  data() {
    return {
      checked: (this.options.options.find((o) => o.text === this.existingValue) || { value: '' }).value,
    };
  },
};
</script>
